module.exports = __webpack_public_path__ + "66eecb4c2300da7772e6fa329a6b85c9.MP3";